// extracted by mini-css-extract-plugin
export default {"lesson-description-desc-wrapper":"lesson-description-desc-wrapper_uviq4"};